export const threatTierKeys = {
  all: ["threatTier"] as const,
};
